<!-- 月度手卫生报告 -->
<template>
  <div class='hospitalStatistics' style='background-color:#fff;padding:40px 15px 15px;' :style='{"max-width":reportData.isWeb==1?"1200px":"","min-width":reportData.isWeb==1?"1000px":"","margin":reportData.isWeb==1?"0 auto":""}'>
    <div class="hospitalStatistics-content">
      <div class="report-title">
        <div>{{reportData.contentObj.reportTitle}}</div>
      </div>
      <div class="report-tips-oblique" v-if='reportData.isWeb!=1'> 【建议下载本文档后在电脑端查看】 </div>
      <div class="report-introduction">手卫生主要是针对医务人员在工作中存在的交叉感染的风险而采取的措施，是医院感染控制的重要手段，是医院常规监测十三项指标之一。通过手卫生，可以有效降低医院感染。为敦促常态化疫情下本院手卫生工作落实，并落实《医院感染管理办法》《医务人员手卫生规范》的要求，配合全国医院感染监控管理培训基地、全国医院感染监测网做好本次全国调查工作。
      </div>
      <div class="report-introduction">【目的】建立医务人员诊疗过程手卫生监测数据的评价体系。对比医院感染发病率、医院感染现患率、多重耐药菌检出率、导尿管相关泌尿道感染发病率、血管导管相关血流感染发病率和呼吸机相关肺炎发病率等，并评价其与手卫生相关性；促进手卫生的持续改进；获取不同规模医疗机构手卫生依从率及手卫生用品床日消耗量作为标杆，为各医院机构提供手卫生执行情况的对照体系，以促进{{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}手卫生持续改进。
      </div>
      <div class="report-introduction">【方法】{{reportData.contentObj.CONTENT2}} - {{reportData.contentObj.CONTENT3}}采用手卫生观察员现场调查方法获取骨科、综合ICU、呼吸科(组)、感染病科(组)、儿科门急诊、血液透析室医疗和护理手卫生执行情况，并统计同期调查科室工作量、手卫生用品消耗量以及医疗机构实际开放床位数，计算手卫生依从率和手卫生用品床日消耗量/人次消耗量。
      </div>
      <div class="report-introduction">【结果】{{reportData.contentObj.CONTENT6}}{{reportData.contentObj1.CONTENT2}}{{reportData.contentObj2.CONTENT2}}{{reportData.contentObj3.CONTENT2}}
      </div>
      <div class="report-introduction">【相关名词定义】： </div>
      <div class="report-introduction">全国{{reportData.contentObj.CONTENT1}}：指全国完成本次监测上报且调查资料审核合格的{{reportData.contentObj.CONTENT1}}</div>
      <div class="report-introduction">区域{{reportData.contentObj.CONTENT1}}：指辖区完成本次监测上报且调查资料审核合格的{{reportData.contentObj.CONTENT1}}</div>
      <div class="report-content">
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-1'>1. 区域手卫生知识知晓率情况 </div>
        <div class="bold" id='hps-1.1'>1.1 区域手卫生学习任务完成情况</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj.CONTENT4'> {{reportData.contentObj.CONTENT4}} </div>
        <div class='surface-description'>表1-1 各区域的学习任务学习完成情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>区域</th>
              <th>参与医疗机构数</th>
              <th>参与人数</th>
              <th>未完成人数</th>
              <th>完成人数</th>
              <th>完成率</th>
            </tr>
          </thead>
          <template v-if="reportData.tableOneData.length>0">
            <tr
              v-for="(item,index) in reportData.tableOneData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.CITY_NAME!=null?item.CITY_NAME:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.USER_NUM2!=null?item.USER_NUM2:'-'}}</td>
              <td>{{item.USER_NUM3!=null?item.USER_NUM3:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>（完成率=完成人数/参与人数*100%）</div>
        <div class='surface-description'>表1-2 各区域单个学习任务的学习完成情况</div>
        <table class="mergeRowTable mergeRowTableCenter" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>区域</th>
              <th>学习任务</th>
              <th>参与医疗机构数</th>
              <th>参与人数</th>
              <th>未完成人数</th>
              <th>完成人数</th>
              <th>完成率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTwoData.length>0'>
            <tbody
              v-for="(item,index) in reportData.tableTwoData"
              :key='index'
              :style="{'background-color':index%2==0?'#fff':'#f1eff1'}"
            >
              <tr v-if='item.dataInfo.length>0'>
                <td :rowspan='item.dataInfo.length' class='childRenItem' >{{item.CITY_NAME!=null?item.CITY_NAME:'-'}}</td>
                <td class='childRenItem' >{{item.dataInfo[0].TASK_ORDER!=null?item.dataInfo[0].TASK_ORDER:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].COM_NUM!=null?item.dataInfo[0].COM_NUM:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].USER_NUM1!=null?item.dataInfo[0].USER_NUM1:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].USER_NUM2!=null?item.dataInfo[0].USER_NUM2:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].USER_NUM3!=null?item.dataInfo[0].USER_NUM3:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].USER_RATE!=null&&item.dataInfo[0].USER_RATE!='-'?item.dataInfo[0].USER_RATE+'%':'-'}}</td>
              </tr>
              <tr v-for="(d,idx) in item.dataInfo" v-if='idx>0' :key='idx' >
                <td class='childRenItem'>{{d.TASK_ORDER!=null?d.TASK_ORDER:'-'}}</td>
                <td class='childRenItem'>{{d.COM_NUM!=null?d.COM_NUM:'-'}}</td>
                <td class='childRenItem'>{{d.USER_NUM1!=null?d.USER_NUM1:'-'}}</td>
                <td class='childRenItem'>{{d.USER_NUM2!=null?d.USER_NUM2:'-'}}</td>
                <td class='childRenItem'>{{d.USER_NUM3!=null?d.USER_NUM3:'-'}}</td>
                <td class='childRenItem'>{{d.USER_RATE!=null&&d.USER_RATE!='-'?d.USER_RATE+'%':'-'}}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody>
              <tr>
                <td
                  colspan='7'
                  style="width:100%;"
                >暂无数据</td>
              </tr>
            </tbody>
          </template>
        </table>
        <div class='surface-description'>（注：学习任务清单见附录1）</div>
        <div class="bold" style='margin-top:10px' id='hps-1.2'>1.2 区域手卫生考试情况</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj.CONTENT5'> {{reportData.contentObj.CONTENT5}} </div>
        <div class='surface-description'>表1-3 不同成绩区间分布（平均成绩区间分布）</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>成绩区间（分）</th>
              <th>人数</th>
              <th>占比</th>
            </tr>
          </thead>
          <template v-if='reportData.tableThreeData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableThreeData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.EXAM_SCORE!=null?item.EXAM_SCORE:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='3'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div
          id="echarts1"
          :class='{"web-echarts-heightFixed":reportData.isWeb==1}'
          v-if="reportData.echartsOneData.length>0&&reportData.contentObj.CONTENT5"
        ></div>
        <div class='surface-description'>表1-4 各区域的考试合格情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>区域</th>
              <th>参与医疗机构数</th>
              <th>参与人数</th>
              <th>平均分</th>
              <th>标准差</th>
              <th>合格率</th>
            </tr>
          </thead>
          <template v-if="reportData.tableFourData.length>0">
            <tr
              v-for="(item,index) in reportData.tableFourData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.CITY_NAME!=null?item.CITY_NAME:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.AVG_SCORE!=null?item.AVG_SCORE:'-'}}</td>
              <td>{{item.STD_SCORE!=null?item.STD_SCORE:'-'}}</td>
              <td>{{item.SCORE_RATE!=null?item.SCORE_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>表1-5 手卫生考试题目的答题正确及错误情况</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>错误率排名</th>
              <th>题目</th>
              <th>答题人次</th>
              <th>正确人次</th>
              <th>错误人次</th>
              <th>错误率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableFiveData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableFiveData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td :colspan="index == reportData.tableFiveData.length-1?2:1">{{item.RANK_NO!=null?item.RANK_NO:'-'}}</td>
              <td v-if='index != reportData.tableFiveData.length-1'>{{item.BIZ_ORDER!=null?item.BIZ_ORDER:'-'}}</td>
              <td>{{item.ANSWER_CNT!=null?item.ANSWER_CNT:'-'}}</td>
              <td>{{item.ANSWER_OK_CNT!=null?item.ANSWER_OK_CNT:'-'}}</td>
              <td>{{item.ANSWER_ERROR_CNT!=null?item.ANSWER_ERROR_CNT:'-'}}</td>
              <td>{{item.ERROR_RATE!=null?item.ERROR_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>（注：手卫生考试题目见附件2）</div>

        <div class="bold" style='margin-top:10px' id='hps-1.3'>1.3 区域手卫生证书获得情况</div>
        <div class='surface-description'>表1-6 {{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}获得证书情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>区域</th>
              <th>参与医疗机构数</th>
              <th>参与人数</th>
              <th>未完成人数</th>
              <th>已获得证书人数</th>
              <th>获得证书占比</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSixData.length>0">
            <tr
              v-for="(item,index) in reportData.tableSixData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.CITY_NAME!=null?item.CITY_NAME:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.USER_NUM2!=null?item.USER_NUM2:'-'}}</td>
              <td>{{item.USER_NUM3!=null?item.USER_NUM3:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>（获得证书占比=已获得证书人数/参与人数*100%）</div>

        <div class="twoLevel-title" style='margin-top:10px;' id='hps-2'>2. 区域调查科室手卫生依从及正确执行情况 </div>
        <div class="bold" id='hps-2.1'>2.1 不同规模医院手卫生时机依从率/正确率</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj1.CONTENT3'> {{reportData.contentObj1.CONTENT3}} </div>
        <div class='surface-description'>表2-1 {{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}手卫生依从执行率/正确率(%)（依从率{{reportData.handComplianceTarget}}%以下标红，正确率{{reportData.handCorrectionTarget}}%以下标红）</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
            <thead>
              <tr>
                <th>实际开放床位数（张）</th>
                <th>参与医疗机构数</th>
                <th>时机数</th>
                <th>手卫生次数</th>
                <th>正确次数</th>
                <th>本区域手卫生依从率</th>
                <th>本区域手卫生正确率</th>
                <th>全国{{reportData.contentObj.CONTENT1}}手卫生依从率</th>
                <th>全国{{reportData.contentObj.CONTENT1}}手卫生正确率</th>
              </tr>
            </thead>
            <template v-if="reportData.tableSevenData.length>0">
              <tr
                v-for="(item,index) in reportData.tableSevenData"
                :key='index'
                :style="{'background-color':index%2!=0?'#f1eff1':''}"
              >
                <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
                <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
                <td>{{item.SWS_CNT1!=null?item.SWS_CNT1:'-'}}</td>
                <td>{{item.SWS_CNT2!=null?item.SWS_CNT2:'-'}}</td>
                <td>{{item.SWS_CNT3!=null?item.SWS_CNT3:'-'}}</td>
                <td :style="{'color':(item.SWS_RATE1&&item.SWS_RATE1<reportData.handComplianceTarget)||item.SWS_RATE1==0?'red':''}">{{item.SWS_RATE1!=null?item.SWS_RATE1+'%':'-'}}</td>
                <td :style="{'color':(item.SWS_RATE2&&item.SWS_RATE2<reportData.handCorrectionTarget)||item.SWS_RATE2==0?'red':''}">{{item.SWS_RATE2!=null?item.SWS_RATE2+'%':'-'}}</td>
                <td :style="{'color':(item.SWS_RATE3&&item.SWS_RATE3<reportData.handComplianceTarget)||item.SWS_RATE3==0?'red':''}">{{item.SWS_RATE3!=null?item.SWS_RATE3+'%':'-'}}</td>
                <td :style="{'color':(item.SWS_RATE4&&item.SWS_RATE4<reportData.handCorrectionTarget)||item.SWS_RATE4==0?'red':''}">{{item.SWS_RATE4!=null?item.SWS_RATE4+'%':'-'}}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  colspan='9'
                  style="width:100%;"
                >暂无数据</td>
              </tr>
            </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts2" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableSevenData.length>0&&reportData.contentObj1.CONTENT3" ></div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts3" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableSevenData.length>0&&reportData.contentObj1.CONTENT3" ></div>
        <div v-else>暂无数据</div>
        <div class="bold" style='margin-top:10px' id='hps-2.2'>2.2 不同指征手卫生时机依从率/正确率</div>
        <div class='surface-description'>表2-2 2021年9月{{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}不同指征手卫生依从及正确执行情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>指征</th>
              <th>指征数</th>
              <th>手卫生次数</th>
              <th>正确数</th>
              <th>本区域手卫生依从率</th>
              <th>本区域手卫生正确率</th>
              <th>全国{{reportData.contentObj.CONTENT1}}手卫生依从率</th>
              <th>全国{{reportData.contentObj.CONTENT1}}手卫生正确率</th>
            </tr>
          </thead>
          <template v-if="reportData.tableEightData.length>0">
            <tr
              v-for="(item,index) in reportData.tableEightData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.SWS_NAME!=null?item.SWS_NAME:'-'}}</td>
              <td>{{item.SWS_CNT1!=null?item.SWS_CNT1:'-'}}</td>
              <td>{{item.SWS_CNT2!=null?item.SWS_CNT2:'-'}}</td>
              <td>{{item.SWS_CNT3!=null?item.SWS_CNT3:'-'}}</td>
              <td :style="{'color':(item.SWS_RATE1&&item.SWS_RATE1<reportData.handComplianceTarget)||item.SWS_RATE1==0?'red':''}">{{item.SWS_RATE1!=null?item.SWS_RATE1+'%':'-'}}</td>
              <td :style="{'color':(item.SWS_RATE2&&item.SWS_RATE2<reportData.handCorrectionTarget)||item.SWS_RATE2==0?'red':''}">{{item.SWS_RATE2!=null?item.SWS_RATE2+'%':'-'}}</td>
              <td :style="{'color':(item.SWS_RATE3&&item.SWS_RATE3<reportData.handComplianceTarget)||item.SWS_RATE3==0?'red':''}">{{item.SWS_RATE3!=null?item.SWS_RATE3+'%':'-'}}</td>
              <td :style="{'color':(item.SWS_RATE4&&item.SWS_RATE4<reportData.handCorrectionTarget)||item.SWS_RATE4==0?'red':''}">{{item.SWS_RATE4!=null?item.SWS_RATE4+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='8'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts4" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableEightData.length>0&&reportData.contentObj1.CONTENT3" ></div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts5" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableEightData.length>0&&reportData.contentObj1.CONTENT3" ></div>
        <div
          class="bold"
          style='margin-top:10px'
          id='hps-2.3'
        >2.3. 不同岗位人员手卫生时机依从率/正确率</div>
        <div class='surface-description'>表2-3 {{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}不同岗位人员时机依从率与正确率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>岗位</th>
              <th>时机数</th>
              <th>手卫生次数</th>
              <th>正确数</th>
              <th>本区域手卫生依从率</th>
              <th>本区域手卫生正确率</th>
              <th>全国{{reportData.contentObj.CONTENT1}}手卫生依从率</th>
              <th>全国{{reportData.contentObj.CONTENT1}}手卫生正确率</th>
            </tr>
          </thead>
          <template v-if="reportData.tableNineData.length>0">
            <tr
              v-for="(item,index) in reportData.tableNineData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.POST_NAME!=null?item.POST_NAME:'-'}}</td>
              <td>{{item.SWS_CNT1!=null?item.SWS_CNT1:'-'}}</td>
              <td>{{item.SWS_CNT2!=null?item.SWS_CNT2:'-'}}</td>
              <td>{{item.SWS_CNT3!=null?item.SWS_CNT3:'-'}}</td>
              <td :style="{'color':(item.SWS_RATE1&&item.SWS_RATE1<reportData.handComplianceTarget)||item.SWS_RATE1==0?'red':''}">{{item.SWS_RATE1!=null?item.SWS_RATE1+'%':'-'}}</td>
              <td :style="{'color':(item.SWS_RATE2&&item.SWS_RATE2<reportData.handCorrectionTarget)||item.SWS_RATE2==0?'red':''}">{{item.SWS_RATE2!=null?item.SWS_RATE2+'%':'-'}}</td>
              <td :style="{'color':(item.SWS_RATE3&&item.SWS_RATE3<reportData.handComplianceTarget)||item.SWS_RATE3==0?'red':''}">{{item.SWS_RATE3!=null?item.SWS_RATE3+'%':'-'}}</td>
              <td :style="{'color':(item.SWS_RATE4&&item.SWS_RATE4<reportData.handCorrectionTarget)||item.SWS_RATE4==0?'red':''}">{{item.SWS_RATE4!=null?item.SWS_RATE4+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='8'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts6" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableNineData.length>0&&reportData.contentObj1.CONTENT3" ></div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts7" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableNineData.length>0&&reportData.contentObj1.CONTENT3" ></div>
        <div class="bold" style='margin-top:10px' id='hps-2.4'>2.4. 不同岗位人员指征依从率/正确率</div>
        <div class='surface-description'>表2-4 {{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}不同岗位指征依从率、正确率</div>
        <table
          class="mergeRowTable mergeRowTableCenter mergeRowTableNotBorder"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>指征</th>
              <th>分类</th>
              <th>护理</th>
              <th>医疗</th>
              <th>医技</th>
              <th>工勤</th>
              <th>其他</th>
              <th>行政管理</th>
              <th>合计</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTenData.length>0'>
            <tbody
              v-for="(item,index) in reportData.tableTenData"
              :key='index'
              :style="{'background-color':index%2==0?'#fff':'#f1eff1'}"
            >
              <tr v-if='item.dataInfo.length>0'>
                <td :rowspan='item.dataInfo.length' class='childRenItem' >{{item.SWS_NAME!=null?item.SWS_NAME:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].RATE_TYPE!=null?item.dataInfo[0].RATE_TYPE:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_1!=null&&item.dataInfo[0].POST_1!='-'?item.dataInfo[0].POST_1+'%':'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_2!=null&&item.dataInfo[0].POST_2!='-'?item.dataInfo[0].POST_2+'%':'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_3}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_4}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_5}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_6}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_7!=null?item.dataInfo[0].POST_7+'%':'-'}}</td>
              </tr>
              <tr
                v-for="(d,idx) in item.dataInfo"
                v-if='idx>0&&item.dataInfo.length>1'
                :key='idx'
              >
                <td class='childRenItem'>{{d.RATE_TYPE!=null?d.RATE_TYPE:'-'}}</td>
                <td class='childRenItem'>{{d.POST_1!=null&&d.POST_1!='-'?d.POST_1+'%':'-'}}</td>
                <td class='childRenItem'>{{d.POST_2!=null&&d.POST_2!='-'?d.POST_2+'%':'-'}}</td>
                <td class='childRenItem'>{{d.POST_3}}</td>
                <td class='childRenItem'>{{d.POST_4}}</td>
                <td class='childRenItem'>{{d.POST_5}}</td>
                <td class='childRenItem'>{{d.POST_6}}</td>
                <td class='childRenItem'>{{d.POST_7!=null?d.POST_7+'%':'-'}}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody>
              <tr>
                <td
                  colspan='9'
                  style="width:100%;text-align:center;"
                >暂无数据</td>
              </tr>
            </tbody>
          </template>
        </table>
        <div
          class="bold"
          style='margin-top:10px'
          id='hps-2.5'
        >2.5 各科室卫生平均依从率/正确率情况</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj1.CONTENT4'> {{reportData.contentObj1.CONTENT4}} </div>
        <div class='surface-description'>表2-5 {{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}调查科室手卫生依从率及正确率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>序号</th>
              <th>调查科室</th>
              <th>医疗机构数</th>
              <th>时机数</th>
              <th>手卫生次数</th>
              <th>依从率</th>
              <th>正确次数</th>
              <th>正确率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableElevenData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableElevenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.RANK_NO!=null?item.RANK_NO:'-'}}</td>
              <td>{{item.DEPY_NAME!=null?item.DEPY_NAME:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.SWS_CNT1!=null?item.SWS_CNT1:'-'}}</td>
              <td>{{item.SWS_CNT2!=null?item.SWS_CNT2:'-'}}</td>
              <td :style="{'color':(item.SWS_RATE1&&item.SWS_RATE1<reportData.handComplianceTarget)||item.SWS_RATE1==0?'red':''}">{{item.SWS_RATE1!=null?item.SWS_RATE1+'%':'-'}}</td>
              <td>{{item.SWS_CNT3!=null?item.SWS_CNT3:'-'}}</td>
              <td :style="{'color':(item.SWS_RATE2&&item.SWS_RATE2<reportData.handCorrectionTarget)||item.SWS_RATE2==0?'red':''}">{{item.SWS_RATE2!=null?item.SWS_RATE2+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='8'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div
          class="bold"
          style='margin-top:10px'
          id='hps-2.6'
        >2.6. 各医疗机构手卫生平均依从率/正确率情况</div>
        <div class='surface-description'>表2-6 {{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}手卫生依从率及正确率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>序号</th>
              <th style='width: 20%;'>医疗机构名称</th>
              <th>时机数</th>
              <th>手卫生次数</th>
              <th>依从率</th>
              <th>正确次数</th>
              <th>正确率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTwelveData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableTwelveData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.RANK_NO!=null?item.RANK_NO:'-'}}</td>
              <td>{{item.COM_NAME!=null?item.COM_NAME:'-'}}</td>
              <td>{{item.SWS_CNT1!=null?item.SWS_CNT1:'-'}}</td>
              <td>{{item.SWS_CNT2!=null?item.SWS_CNT2:'-'}}</td>
              <td :style="{'color':(item.SWS_RATE1&&item.SWS_RATE1<reportData.handComplianceTarget)||item.SWS_RATE1==0?'red':''}">{{item.SWS_RATE1!=null&&item.SWS_RATE1!='--'?item.SWS_RATE1+'%':'--'}}</td>
              <td>{{item.SWS_CNT3!=null?item.SWS_CNT3:'-'}}</td>
              <td :style="{'color':(item.SWS_RATE2&&item.SWS_RATE2<reportData.handCorrectionTarget)||item.SWS_RATE2==0?'red':''}">{{item.SWS_RATE2!=null&&item.SWS_RATE2!='--'?item.SWS_RATE2+'%':'--'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='7'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-3'>3. 区域调查科室手卫生用品消耗情况</div>
        <div class="bold" id='hps-3.1'>3.1 各科室手卫生用品消耗调查概况</div>
        <div class="hps-3-box" v-if='reportData.contentObj2.CONTENT3'>
        <div class="report-paragraph  report-paragraph-lh25">{{reportData.contentObj2.CONTENT3}}</div>
        <div class='surface-description'>表3-1 2021年9月{{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}不同科室每床日手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>科室</th>
              <th>参与医疗机构数</th>
              <th>实际开放床位数</th>
              <th>住院床日数</th>
              <th>手卫生用品消耗量(mL)</th>
              <th>消耗量(mL/床日)</th>
              <th>手卫生次数(次/床日)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableThirteenData.length>1">
            <tr
              v-for="(item,index) in reportData.tableThirteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.DEPT_NAME!=null?item.DEPT_NAME:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.OPEN_BEDS!=null?item.OPEN_BEDS:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='7'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>(注：按照每次手卫生取用量2.5mL折算手卫生次数)</div>
        <div class='surface-description'>表3-2 2021年9月{{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}不同科室每人次(患者)手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>科室</th>
              <th>参与医疗机构数</th>
              <th>儿科门急诊人次</th>
              <th>手卫生用品消耗量(mL)</th>
              <th>消耗量(mL/人次)</th>
              <th>手卫生次数(次/人次)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableFourteenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableFourteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.DEPT_NAME!=null?item.DEPT_NAME:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>表3-3 2021年9月{{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}血液透析室每人次(患者)手套消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>科室</th>
              <th>参与医疗机构数</th>
              <th>血液透析人次</th>
              <th>手套消耗总量(双)</th>
              <th>手套(双/人次)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableFifteenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableFifteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.DEPT_NAME!=null?item.DEPT_NAME:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='5'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        </div>
        <div v-else>未上报数据</div>
        <div class="bold" id='hps-3.2' style='margin-top:10px;'>3.2 不同规模医疗机构各科室手卫生用品消耗情况</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj2.CONTENT4'> {{reportData.contentObj2.CONTENT4}} </div>
        <div class="bold" style='margin-top:10px;' id='hps-3.2.1'>3.2.1 【骨科】手卫生用品消耗情况</div>
        <div class='surface-description'>表3-4 2021年9月{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}骨科手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>住院床日数</th>
              <th>手卫生用品消耗量（mL）</th>
              <th>本区域消耗量(mL/床日)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}消耗量(mL/床日)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSixteenData[0].dataInfo.length>0">
            <tr
              v-for="(item,index) in reportData.tableSixteenData[0].dataInfo"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts8" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.contentObj2.CONTENT4" ></div>

        <div class="bold" style='margin-top:10px;' id='hps-3.2.2'>3.2.2 【呼吸科(组)】手卫生用品消耗情况</div>
        <div class='surface-description'>表3-5 2021年9月{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}呼吸科(组)手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>住院床日数</th>
              <th>手卫生用品消耗量（mL）</th>
              <th>本区域消耗量(mL/床日)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}消耗量(mL/床日)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSixteenData[2].dataInfo.length>0">
            <tr
              v-for="(item,index) in reportData.tableSixteenData[2].dataInfo"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts9" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.contentObj2.CONTENT4" ></div>

        <div class="bold" style='margin-top:10px;' id='hps-3.2.3'>3.2.3 【感染病科(组)】手卫生用品消耗情况</div>
        <div class='surface-description'>表3-6 2021年9月{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}感染病科(组)卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>住院床日数</th>
              <th>手卫生用品消耗量（mL）</th>
              <th>本区域消耗量(mL/床日)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}消耗量(mL/床日)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSixteenData[3].dataInfo.length>0">
            <tr
              v-for="(item,index) in reportData.tableSixteenData[3].dataInfo"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts10" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.contentObj2.CONTENT4" ></div>

        <div class="bold" style='margin-top:10px;' id='hps-3.2.4'>3.2.4 【综合ICU】手卫生用品消耗情况</div>
        <div class='surface-description'>表3-7 2021年9月{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}综合ICU手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>住院床日数</th>
              <th>手卫生用品消耗量（mL）</th>
              <th>本区域消耗量(mL/床日)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}消耗量(mL/床日)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSixteenData[1].dataInfo.length>0">
            <tr
              v-for="(item,index) in reportData.tableSixteenData[1].dataInfo"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts11" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.contentObj2.CONTENT4" ></div>

        <div class="bold" style='margin-top:10px;' id='hps-3.2.5'>3.2.5 【儿科门急诊】手卫生用品消耗情况</div>
        <div class='surface-description'>表3-8 2021年9月{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}儿科门急诊手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>儿科门急诊人次</th>
              <th>手卫生用品消耗量（mL）</th>
              <th>本区域消耗量(mL/人次)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}消耗量(mL/人次)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSeventeenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableSeventeenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts12" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableSeventeenData.length>0" ></div>

        <div class="bold" style='margin-top:10px;' id='hps-3.2.6'>3.2.6 【血液透析室】手卫生用品/手套消耗情况</div>
        <div class='surface-description'>表3-9 2021年9月{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}血液透析室手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>血液透析人次</th>
              <th>手卫生用品消耗量（mL）</th>
              <th>本区域消耗量(mL/人次)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}消耗量(mL/人次)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableEighteenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableEighteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME1!=null?item.CONSUME1:'-'}}</td>
              <td>{{item.CONSUME2!=null?item.CONSUME2:'-'}}</td>
              <td>{{item.CONSUME3!=null?item.CONSUME3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts13" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableEighteenData.length>0" ></div>

        <div class='surface-description'>表3-10 2021年9月{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}血液透析室手套消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>血液透析人次</th>
              <th>手套消耗总量(双)</th>
              <th>本区域消耗量(双/人次)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}消耗量(双/人次)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableNineteenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableNineteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.GOLVES1!=null?item.GOLVES1:'-'}}</td>
              <td>{{item.GOLVES2!=null?item.GOLVES2:'-'}}</td>
              <td>{{item.GOLVES3!=null?item.GOLVES3:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts14" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableNineteenData.length>0" ></div>
        
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-4'>4. 区域重点质控指标情况</div>
        <div class="bold" id='hps-4.1'>4.1 2020年重点质控指标概况</div>
        <div class='surface-description'>表4-1 2020年{{reportData.contentObj.CONTENT0}}{{reportData.contentObj.CONTENT1}}重点质控指标</div>
        <table
          class="mergeRowTable mergeRowTableCenter mergeRowTableNotBorder"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
         <thead>
            <tr>
              <th style='width: 30%;'>一级指标</th>
              <th style='width: 30%;'>二级指标</th>
              <th>本区域</th>
              <th>全国{{reportData.contentObj.CONTENT1}}</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTwentyData.length>0'>
            <tbody
              v-for="(item,index) in reportData.tableTwentyData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <tr v-if='item.dataInfo.length>0'>
                <td :rowspan='item.dataInfo.length' class='childRenItem'>{{item.INDEX_NAME!=null?item.INDEX_NAME:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].OPTION_NAME!=null?item.dataInfo[0].OPTION_NAME:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].OPTION_VALUE1!=null?item.dataInfo[0].OPTION_VALUE1:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].OPTION_VALUE2!=null?item.dataInfo[0].OPTION_VALUE2:'-'}}</td>
              </tr>
              <tr
                v-for="(d,idx) in item.dataInfo"
                v-if='idx>0&&item.dataInfo.length>1'
                :key='idx'
              >
                <td class='childRenItem'>{{d.OPTION_NAME!=null?d.OPTION_NAME:'-'}}</td>
                <td class='childRenItem'>{{d.OPTION_VALUE1!=null?d.OPTION_VALUE1:'-'}}</td>
                <td class='childRenItem'>{{d.OPTION_VALUE2!=null?d.OPTION_VALUE2:'-'}}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody>
              <tr>
                <td
                  colspan='4'
                  style="width:100%;text-align:center;"
                >暂无数据</td>
              </tr>
            </tbody>
          </template>
        </table>
        <div class="bold" id='hps-4.2' style='margin-top:10px;'>4.2 不同规模医疗机构2020年重点质控指标情况</div>
        <div class='surface-description'>表4-2 2020年{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}医院感染发病情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>全年出院人数</th>
              <th>年末在院患者人数</th>
              <th>同期新发医院感染病例数</th>
              <th>本区域医院感染发病率(%)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}感染发病率(%)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableTwentyOneData.length>0">
            <tr
              v-for="(item,index) in reportData.tableTwentyOneData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.OPTION_NUM1!=null?item.OPTION_NUM1:'-'}}</td>
              <td>{{item.OPTION_NUM2!=null?item.OPTION_NUM2:'-'}}</td>
              <td>{{item.OPTION_NUM3!=null?item.OPTION_NUM3:'-'}}</td>
              <td>{{item.OPTION_RATE1!=null?item.OPTION_RATE1:'-'}}</td>
              <td>{{item.OPTION_RATE2!=null?item.OPTION_RATE2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='7'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts15" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableTwentyOneData.length>0" ></div>

        <div class='surface-description'>表4-3 2020年{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}感染现患情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>同期现患率调查人数</th>
              <th>同期现患率感染人数</th>
              <th>本区域医院感染现患率(%)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}感染现患率(%)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableTwentyTwoData.length>0">
            <tr
              v-for="(item,index) in reportData.tableTwentyTwoData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.OPTION_NUM1!=null?item.OPTION_NUM1:'-'}}</td>
              <td>{{item.OPTION_NUM2!=null?item.OPTION_NUM2:'-'}}</td>
              <td>{{item.OPTION_RATE1!=null?item.OPTION_RATE1:'-'}}</td>
              <td>{{item.OPTION_RATE2!=null?item.OPTION_RATE2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts16" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableTwentyTwoData.length>0" ></div>

        <div class='surface-description'>表4-4 {{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}多重耐药菌检出情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>同期该病原体检出菌株总数</th>
              <th>同期多重耐药菌株数</th>
              <th>本区域多重耐药菌检出率(%)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}多重耐药菌检出率(%)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableTwentyThreeData.length>0">
            <tr
              v-for="(item,index) in reportData.tableTwentyThreeData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.OPTION_NUM1!=null?item.OPTION_NUM1:'-'}}</td>
              <td>{{item.OPTION_NUM2!=null?item.OPTION_NUM2:'-'}}</td>
              <td>{{item.OPTION_RATE1!=null?item.OPTION_RATE1:'-'}}</td>
              <td>{{item.OPTION_RATE2!=null?item.OPTION_RATE2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts17" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableTwentyThreeData.length>0" ></div>

        <div class='surface-description'>表4-5 2020年{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}综合ICU血管导管相关血流感染发病情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>同期中央血管导管留置总天数</th>
              <th>同期新发导管相关血流感染例次数</th>
              <th>本区域VCAI(‰)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}VCAI(‰)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableTwentyFourData.length>0">
            <tr
              v-for="(item,index) in reportData.tableTwentyFourData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.OPTION_NUM1!=null?item.OPTION_NUM1:'-'}}</td>
              <td>{{item.OPTION_NUM2!=null?item.OPTION_NUM2:'-'}}</td>
              <td>{{item.OPTION_RATE1!=null?item.OPTION_RATE1:'-'}}</td>
              <td>{{item.OPTION_RATE2!=null?item.OPTION_RATE2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts18" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableTwentyFourData.length>0" ></div>

        <div class='surface-description'>表4-6 2020年{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}综合ICU呼吸机相关肺炎感染发病情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>同期呼吸机使用总天数</th>
              <th>同期呼吸机相关肺炎感染例次数</th>
              <th>本区域VAP(‰)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}VAP(‰)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableTwentyFiveData.length>0">
            <tr
              v-for="(item,index) in reportData.tableTwentyFiveData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.OPTION_NUM1!=null?item.OPTION_NUM1:'-'}}</td>
              <td>{{item.OPTION_NUM2!=null?item.OPTION_NUM2:'-'}}</td>
              <td>{{item.OPTION_RATE1!=null?item.OPTION_RATE1:'-'}}</td>
              <td>{{item.OPTION_RATE2!=null?item.OPTION_RATE2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts19" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableTwentyFiveData.length>0" ></div>

        <div class='surface-description'>表4-7 2020年{{reportData.contentObj.CONTENT0}}不同规模{{reportData.contentObj.CONTENT1}}综合ICU导尿管相关泌尿道感染发病情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>实际开放床位数（张）</th>
              <th>参与医疗机构</th>
              <th>同期导尿管使用总天数</th>
              <th>同期导尿管相关泌尿道感染例次数</th>
              <th>本区域CAUTI(‰)</th>
              <th>全国{{reportData.contentObj.CONTENT1}}CAUTI(‰)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableTwentySixData.length>0">
            <tr
              v-for="(item,index) in reportData.tableTwentySixData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.COM_SCALE!=null?item.COM_SCALE:'-'}}</td>
              <td>{{item.COM_NUM!=null?item.COM_NUM:'-'}}</td>
              <td>{{item.OPTION_NUM1!=null?item.OPTION_NUM1:'-'}}</td>
              <td>{{item.OPTION_NUM2!=null?item.OPTION_NUM2:'-'}}</td>
              <td>{{item.OPTION_RATE1!=null?item.OPTION_RATE1:'-'}}</td>
              <td>{{item.OPTION_RATE2!=null?item.OPTION_RATE2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts20" :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}' v-if="reportData.tableTwentySixData.length>0" ></div>

        
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-5'>5. 管理提示</div>
        <div class="bold" id='hps-5.1'>5.1 手卫生依从率与手卫生用品消耗量相关性分析</div>
        <div class='surface-description'>图5-1  综合ICU手卫生用品消耗量与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts21"></div>
        <div class='surface-description'>图5-2 呼吸科(组)手卫生用品消耗量与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts22"></div>
        <div class='surface-description'>图5-3 骨科手卫生用品消耗量与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts23"></div>
        <div class='surface-description'>图5-4 儿科门急诊手卫生用品消耗量与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts24"></div>
        <div class='surface-description'>图5-5 血液透析室手卫生用品消耗量与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts25"></div>
        <div class='surface-description'>图5-6 感染病科(组)手卫生用品消耗量与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts26"></div>

        <div class="bold" id='hps-5.2' style='margin-top:10px;'>5.2 手卫生依从率与重点质控指标相关性分析</div>
        <div class='surface-description'>图5-7 医院感染发病率与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts27"></div>
        <div class='surface-description'>图5-8 医院感染现患率与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts28"></div>
        <div class='surface-description'>图5-9 多重耐药菌检出率与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts29"></div>
        <div class='surface-description'>图5-10 综合ICU血管导管相关血流感染发病率与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts30"></div>
        <div class='surface-description'>图5-11 综合ICU呼吸机相关肺炎感染发病率与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts31"></div>
        <div class='surface-description'>图5-12 综合ICU导尿管相关泌尿道感染发病率与手卫生依从率的相关性</div>
        <div class='v-echarts' :class='{"web-echarts-heightFixed":reportData.isWeb==1}' id="echarts32"></div>



        <div class="" style='margin-top:20px;'>温馨提示：可登录感控工作间后台获取更详细的报表 </div>
        <div class="">1、后台地址：<span style='color:#26b4ff;text-decoration:underline;'>{{pcUrl}}</span> </div>
        <div class="">2、账号和密码：同登录感控工作间APP一致 </div>
        <div class="">3、获取权限：仅限已开通区域管理员权限的才可以获取报表 </div>
        <div class="">4、获取路径：区域任务→全国手卫生监测上报→详情 </div>
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-fu1'>附1 手卫生知识学习任务清单</div>
        <table class="mergeRowTable mergeRowTableTwo mergeRowTableCenter" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th style='width:10%'>序号</th>
              <th style='width:20%'>情景</th>
              <th style='width:70%'>学习课时</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTwentySevenData.length>0'>
            <tbody v-for="(item,index) in reportData.tableTwentySevenData" :key='index' :style="{'background-color':index%2==0?'#fff':'#f1eff1'}" >
              <tr v-if='item.dataInfo.length>0'>
                <td :rowspan='item.dataInfo.length' class='childRenItem' >{{item.TASK_ORDER!=null?item.TASK_ORDER:'-'}}</td>
                <td :rowspan='item.dataInfo.length' class='childRenItem' style='text-align:left;'>{{item.TASK_NAME!=null?item.TASK_NAME:'-'}}</td>
                <td class='childRenItem' style='text-align:left;'>{{item.dataInfo[0].BIZ_NAME!=null?item.dataInfo[0].BIZ_NAME:'-'}}</td>
              </tr>
              <tr v-for="(d,idx) in item.dataInfo" v-if='idx>0' :key='idx' >
                <td class='childRenItem' style='text-align:left;'>{{d.BIZ_NAME!=null?d.BIZ_NAME:'-'}}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody>
              <tr> <td colspan='3' style="width:100%;text-align:center;" >暂无数据</td>
              </tr>
            </tbody>
          </template>
        </table>
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-fu2'>附2 手卫生考试题目</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th style='width:10%'>序号</th>
              <th style='width:20%'>题型</th>
              <th style='width:70%'>题干</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTwentyEightData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableTwentyEightData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.BIZ_ORDER!=null?item.BIZ_ORDER:'-'}}</td>
              <td>{{item.QST_TYPE_NAME!=null?item.QST_TYPE_NAME:'-'}}</td>
              <td style='text-align:left;'>{{item.BIZ_NAME!=null?item.BIZ_NAME:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='3'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
  import * as ecStat from 'echarts-stat';
  export default {
    name: 'hospitalStatistics',
    props: ['reportData'],
    data() {
      return {
        source: '',
        pcUrl:'https://dygk.gkgzj.com/incontrol-manager/account/toLoginIndex',
        echartsChildData: {},
      }
    },
    created() {
      this.source = this.$route.query.source
      this.initEcharts()
      this.$emit('sendEchartsImg', this.echartsChildData)
    },
    methods: {
      initEcharts() {
        this.$nextTick(() => {
          if (this.reportData.echartsOneData.length > 0 && this.reportData.contentObj.CONTENT5) {
            this.drawEchartsPie('echarts1', this.reportData.echartsOneData)
          }
          
          if (this.reportData.tableSevenData.length > 0 && this.reportData.contentObj1.CONTENT3) {
            this.drawEchartsBar('echarts2', this.reportData.tableSevenData)
          }
          if (this.reportData.tableSevenData.length > 0 && this.reportData.contentObj1.CONTENT3) {
            this.drawEchartsBar('echarts3', this.reportData.tableSevenData)
          }
          if (this.reportData.tableEightData.length > 0 && this.reportData.contentObj1.CONTENT3) {
            this.drawEchartsBar('echarts4', this.reportData.tableEightData)
          }
          if (this.reportData.tableEightData.length > 0 && this.reportData.contentObj1.CONTENT3) {
            this.drawEchartsBar('echarts5', this.reportData.tableEightData)
          }
          if (this.reportData.tableNineData.length > 0 && this.reportData.contentObj1.CONTENT3) {
            this.drawEchartsBar('echarts6', this.reportData.tableNineData)
          }
          if (this.reportData.tableNineData.length > 0 && this.reportData.contentObj1.CONTENT3) {
            this.drawEchartsBar('echarts7', this.reportData.tableNineData)
          }
          if (this.reportData.tableSixteenData[0].dataInfo.length > 0 && this.reportData.contentObj2.CONTENT4) {
            this.drawEchartsBar('echarts8', this.reportData.tableSixteenData[0].dataInfo)
          }
          if (this.reportData.tableSixteenData[2].dataInfo.length > 0 && this.reportData.contentObj2.CONTENT4) {
            this.drawEchartsBar('echarts9', this.reportData.tableSixteenData[2].dataInfo)
          }
          if (this.reportData.tableSixteenData[3].dataInfo.length > 0 && this.reportData.contentObj2.CONTENT4) {
            this.drawEchartsBar('echarts10', this.reportData.tableSixteenData[3].dataInfo)
          }
          if (this.reportData.tableSixteenData[1].dataInfo.length > 0 && this.reportData.contentObj2.CONTENT4) {
            this.drawEchartsBar('echarts11', this.reportData.tableSixteenData[1].dataInfo)
          }
          if (this.reportData.tableSeventeenData.length > 0) {
            this.drawEchartsBar('echarts12', this.reportData.tableSeventeenData)
          }
          if (this.reportData.tableEighteenData.length > 0) {
            this.drawEchartsBar('echarts13', this.reportData.tableEighteenData)
          }
          if (this.reportData.tableNineteenData.length > 0) {
            this.drawEchartsBar('echarts14', this.reportData.tableNineteenData)
          }
          if (this.reportData.tableTwentyOneData.length > 0) {
            this.drawEchartsBar('echarts15', this.reportData.tableTwentyOneData)
          }
          if (this.reportData.tableTwentyTwoData.length > 0) {
            this.drawEchartsBar('echarts16', this.reportData.tableTwentyTwoData)
          }
          if (this.reportData.tableTwentyThreeData.length > 0) {
            this.drawEchartsBar('echarts17', this.reportData.tableTwentyThreeData)
          }
          if (this.reportData.tableTwentyFourData.length > 0) {
            this.drawEchartsBar('echarts18', this.reportData.tableTwentyFourData)
          }
          if (this.reportData.tableTwentyFiveData.length > 0) {
            this.drawEchartsBar('echarts19', this.reportData.tableTwentyFiveData)
          }
          if (this.reportData.tableTwentySixData.length > 0) {
            this.drawEchartsBar('echarts20', this.reportData.tableTwentySixData)
          }

          if(this.reportData.echartsTwoData.length>0){
            this.drawEchartsScatter('echarts21',this.reportData.echartsTwoData,'综合ICU手卫生用品消耗量与手卫生依从率','综合ICU手卫生用品消耗量')
          }
          if(this.reportData.echartsThreeData.length>0){
            this.drawEchartsScatter('echarts22',this.reportData.echartsThreeData,'呼吸科(组)手卫生用品消耗量与手卫生依从率','呼吸科(组)手卫生用品消耗量')
          }
          if(this.reportData.echartsFourData.length>0){
            this.drawEchartsScatter('echarts23',this.reportData.echartsFourData,'骨科手卫生用品消耗量与手卫生依从率','骨科手卫生用品消耗量')
          }
          if(this.reportData.echartsFiveData.length>0){
            this.drawEchartsScatter('echarts24',this.reportData.echartsFiveData,'儿科门急诊手卫生用品消耗量与手卫生依从率','儿科门急诊手卫生用品消耗量')
          }
          if(this.reportData.echartsSixData.length>0){
            this.drawEchartsScatter('echarts25',this.reportData.echartsSixData,'血液透析室手卫生用品消耗量与手卫生依从率','血液透析室手卫生用品消耗量')
          }
          if(this.reportData.echartsSevenData.length>0){
            this.drawEchartsScatter('echarts26',this.reportData.echartsSevenData,'感染病科(组)手卫生用品消耗量与手卫生依从率','感染病科(组)手卫生用品消耗量')
          }

          if(this.reportData.echartsEightData.length>0){
            this.drawEchartsScatter('echarts27',this.reportData.echartsEightData,'医院感染发病率与手卫生依从率','医院感染发病率','%')
          }
          if(this.reportData.echartsNineData.length>0){
            this.drawEchartsScatter('echarts28',this.reportData.echartsNineData,'医院感染现患率与手卫生依从率','医院感染现患率','%')
          }
          if(this.reportData.echartsTenData.length>0){
            this.drawEchartsScatter('echarts29',this.reportData.echartsTenData,'多重耐药菌检出率与手卫生依从率','多重耐药菌检出率','%')
          }
          if(this.reportData.echartsElevenData.length>0){
            this.drawEchartsScatter('echarts30',this.reportData.echartsElevenData,'血管导管相关血流感染发病率与手卫生依从率','血管导管相关血流感染发病率','‰')
          }
          if(this.reportData.echartsTwelveData.length>0){
            this.drawEchartsScatter('echarts31',this.reportData.echartsTwelveData,'呼吸机相关肺炎感染发病率与手卫生依从率','呼吸机相关肺炎感染发病率','‰')
          }
          if(this.reportData.echartsThirteenData.length>0){
            this.drawEchartsScatter('echarts32',this.reportData.echartsThirteenData,'导尿管相关泌尿道感染发病率与手卫生依从率','导尿管相关泌尿道感染发病率','‰')
          }
        })
      },
      // dataURL 转 Blob对象
      dataURLtoBlob(dataurl) {
        let arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1]
        // console.log(arr, mime);
        let bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], { type: mime })
      },
      drawEchartsPie(id) {
        if (this.reportData.echartsOneData.length > 0) {
          let pieOneData = []
          let scoreName = []
          this.reportData.echartsOneData.map((item,index) => {
            pieOneData.push({
              name: item.EXAM_SCORE,
              value: item.USER_NUM1==0?'':item.USER_NUM1, // 饼图去除为0数据
              value1: item.USER_RATE,
            })
            scoreName.push(item.EXAM_SCORE)
          })
          var option = {
            animation: false,
            tooltip: {
              trigger: 'item',
              formatter: function formatter(params) {
                return ( params.marker + ' ' + params.data.name + ' : ' + params.data.value1 + '%' )
              },
            },
            legend: {
              orient: 'horizontal',
              // top: 5,
              bottom:5,
              textStyle: {
                fontSize: this.reportData.isWeb?20:12,
                color: '#444'
              },
              data: scoreName
            },
            color: ['#6073f5', '#ff9502', '#ff6890', '#01e1ce', '#94d808', '#BD1910'],
            series: [
              {
                name: '成绩分布情况',
                type: 'pie',
                radius: '55%',
                center: ['50%', '50%'],
                data: pieOneData,
                avoidLabelOverlap: true,
                // minAngle: 10, // 控制最小角度
                itemStyle: {
                  normal:{ 
                    label:{ 
                        show: true, 
                        fontSize: this.reportData.isWeb?20:12,
                        formatter: '{b} \n {d}%' 
                    }, 
                    labelLine :{show:true} 
                  } 
                },
                label: {
                  color: '#444',
                  position: 'outside',
                  normal:{
                    overflow:'none'
                  }
                },
                labelLine: {
                  show: true,
                  length: 20,
                  length2: 20,
                },
              },
            ],
          }

          let myChart = this.$echarts.init(document.getElementById(id))
          myChart.setOption(option, true)
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl1 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl1 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl1
            )
          })
        }
      },
      drawEchartsBar(id,data){
        let echartsTitle = ''
        let legendData = []
        if(id == 'echarts2'){
          legendData = ['本区域手卫生依从率', '全国'+ this.reportData.contentObj.CONTENT1 +'手卫生依从率']
          echartsTitle = '与全国'+ this.reportData.contentObj.CONTENT1 +'比较手卫生依从率'
        }else if(id == 'echarts3'){
          legendData = ['本区域手卫生正确率', '全国'+ this.reportData.contentObj.CONTENT1 +'手卫生正确率']
          echartsTitle = '与全国'+ this.reportData.contentObj.CONTENT1 +'比较手卫生正确率'
        }else if(id == 'echarts4'){
          legendData = ['本区域手卫生依从率', '全国'+ this.reportData.contentObj.CONTENT1 +'手卫生依从率']
          echartsTitle = '与全国'+ this.reportData.contentObj.CONTENT1 +'比较WHO五个指征手卫生依从率'
        }else if(id == 'echarts5'){
          legendData = ['本区域手卫生正确率', '全国'+ this.reportData.contentObj.CONTENT1 +'手卫生正确率']
          echartsTitle = '与全国'+ this.reportData.contentObj.CONTENT1 +'比较WHO五个指征手卫生正确率'
        }else if(id == 'echarts6'){
          legendData = ['本区域手卫生依从率', '全国'+ this.reportData.contentObj.CONTENT1 +'手卫生依从率']
          echartsTitle = '与全国'+ this.reportData.contentObj.CONTENT1 +'比较不同岗位手卫生依从率'
        }else if(id == 'echarts7'){
          legendData = ['本区域手卫生正确率', '全国'+ this.reportData.contentObj.CONTENT1 +'手卫生正确率']
          echartsTitle = '与全国'+ this.reportData.contentObj.CONTENT1 +'比较不同岗位手卫生正确率'
        }else if(id == 'echarts8'){
          legendData = ['本区域消耗量(mL/床日)', '全国'+ this.reportData.contentObj.CONTENT1 +'消耗量(mL/床日)']
          echartsTitle = '【骨科】不同规模手卫生用品消耗量情况'
        }else if(id == 'echarts9'){
          legendData = ['本区域消耗量(mL/床日)', '全国'+ this.reportData.contentObj.CONTENT1 +'消耗量(mL/床日)']
          echartsTitle = '【呼吸科(组)】不同规模'+ this.reportData.contentObj.CONTENT1 +'手卫生用品消耗量情况'
        }else if(id == 'echarts10'){
          legendData = ['本区域消耗量(mL/床日)', '全国'+ this.reportData.contentObj.CONTENT1 +'消耗量(mL/床日)']
          echartsTitle = '【感染病科(组)】不同规模'+ this.reportData.contentObj.CONTENT1 +'手卫生用品消耗量情况'
        }else if(id == 'echarts11'){
          legendData = ['本区域消耗量(mL/床日)', '全国'+ this.reportData.contentObj.CONTENT1 +'消耗量(mL/床日)']
          echartsTitle = '【综合ICU】不同规模'+ this.reportData.contentObj.CONTENT1 +'手卫生用品消耗量情况'
        }else if(id == 'echarts12'){
          legendData = ['本区域消耗量(mL/人次)', '全国'+ this.reportData.contentObj.CONTENT1 +'消耗量(mL/人次)']
          echartsTitle = '【儿科门急诊】不同规模'+ this.reportData.contentObj.CONTENT1 +'手卫生用品消耗量情况'
        }else if(id == 'echarts13'){
          legendData = ['本区域消耗量(mL/人次)', '全国'+ this.reportData.contentObj.CONTENT1 +'消耗量(mL/人次)']
          echartsTitle = '【血液透析室】不同规模'+ this.reportData.contentObj.CONTENT1 +'手卫生用品消耗量情况'
        }else if(id == 'echarts14'){
          legendData = ['本区域消耗量(双/人次)', '全国'+ this.reportData.contentObj.CONTENT1 +'消耗量(双/人次)']
          echartsTitle = '【血液透析室】不同规模'+ this.reportData.contentObj.CONTENT1 +'手套消耗量情况'
        }else if(id == 'echarts15'){
          legendData = ['本区域医院感染发病率(%)', '全国'+ this.reportData.contentObj.CONTENT1 +'感染发病率(%)']
          echartsTitle = '不同规模'+ this.reportData.contentObj.CONTENT1 +'感染发病情况'
        }else if(id == 'echarts16'){
          legendData = ['本区域医院感染现患率(%)', '全国'+ this.reportData.contentObj.CONTENT1 +'感染现患率(%)']
          echartsTitle = '不同规模'+ this.reportData.contentObj.CONTENT1 +'感染现患情况'
        }else if(id == 'echarts17'){
          legendData = ['本区域多重耐药菌检出率(%)', '全国'+ this.reportData.contentObj.CONTENT1 +'多重耐药菌检出率(%)']
          echartsTitle = '不同规模'+ this.reportData.contentObj.CONTENT1 +'多重耐药菌检出情况'
        }else if(id == 'echarts18'){
          legendData = ['本区域VCAI(‰)', '全国'+ this.reportData.contentObj.CONTENT1 +'VCAI(‰)']
          echartsTitle = '不同规模'+ this.reportData.contentObj.CONTENT1 +'综合ICU血管导管相关血流感染发病情况'
        }else if(id == 'echarts19'){
          legendData = ['本区域VAP(‰)', '全国'+ this.reportData.contentObj.CONTENT1 +'VAP(‰)']
          echartsTitle = '不同规模'+ this.reportData.contentObj.CONTENT1 +'综合ICU呼吸机相关肺炎感染发病情况'
        }else if(id == 'echarts20'){
          legendData = ['本区域CAUTI(‰)', '全国'+ this.reportData.contentObj.CONTENT1 +'CAUTI(‰)']
          echartsTitle = '不同规模'+ this.reportData.contentObj.CONTENT1 +'综合ICU导尿管相关泌尿道感染发病情况'
        }
        var xData = []
        var data1 = []
        var data2 = []
        for (var i = 0; i <= data.length - 1; i++) {
          var item = data[i]
          if(id == 'echarts2' || id == 'echarts4'){
            if(i != data.length - 1){
              if(id == 'echarts2'){
                xData.push(item.COM_SCALE)
              }else if(id == 'echarts4'){
                xData.push(item.SWS_NAME)
              }
              data1.push(item.SWS_RATE1 ? item.SWS_RATE1 : 0)
              data2.push(item.SWS_RATE3 ? item.SWS_RATE3 : 0)
            }
          }else if (id == 'echarts3' || id == 'echarts5') {
            if(i != data.length - 1){
              if(id == 'echarts3'){
                xData.push(item.COM_SCALE)
              }else if(id == 'echarts5'){
                xData.push(item.SWS_NAME)
              }
              data1.push(item.SWS_RATE2 ? item.SWS_RATE2 : 0)
              data2.push(item.SWS_RATE4 ? item.SWS_RATE4 : 0)
            }
          }else if (id == 'echarts6'){
            xData.push(item.POST_NAME)
            data1.push(item.SWS_RATE1 ? item.SWS_RATE1 : 0)
            data2.push(item.SWS_RATE3 ? item.SWS_RATE3 : 0)
          }else if (id == 'echarts7'){
            xData.push(item.POST_NAME)
            data1.push(item.SWS_RATE2 ? item.SWS_RATE2 : 0)
            data2.push(item.SWS_RATE4 ? item.SWS_RATE4 : 0)
          }else if (id == 'echarts8' || id == 'echarts9' || id == 'echarts10' || id == 'echarts11' || id == 'echarts12' || id == 'echarts13'){
            if(i != data.length - 1){
              xData.push(item.COM_SCALE)
              data1.push(item.CONSUME2 ? item.CONSUME2 : 0)
              data2.push(item.CONSUME3 ? item.CONSUME3 : 0)
            }
          }else if(id == 'echarts14'){
            if(i != data.length - 1){
              xData.push(item.COM_SCALE)
              data1.push(item.GOLVES2 ? item.GOLVES2 : 0)
              data2.push(item.GOLVES3 ? item.GOLVES3 : 0)
            }
          }else if (id == 'echarts15' || id == 'echarts16' || id == 'echarts17' || id == 'echarts18' || id == 'echarts19' || id == 'echarts20'){
            if(i != data.length - 1){
              xData.push(item.COM_SCALE)
              data1.push(item.OPTION_RATE1 ? item.OPTION_RATE1 : 0)
              data2.push(item.OPTION_RATE2 ? item.OPTION_RATE2 : 0)
            }
          }
        }
        var option = {
          animation: false,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            formatter: function formatter(params) {
              var result = ''
              for (var i = 0; i < params.length; i++) {
                var item = params[i]
                result +=
                  item.marker +
                  ' ' +
                  item.seriesName +
                  ' : ' +
                  item.value + (id=='echarts2'||id=='echarts3'||id=='echarts4'||id=='echarts5'||id=='echarts6'||id=='echarts7'?'%</br>':'</br>')
              }
              return result
            },
            extraCssText: 'z-index:999;', //设置层级
          },
          title:{
            text:echartsTitle,
            left: 'center',
            textStyle:{
              //文字颜色
              color:'#333',
              fontWeight: 'bold',
              fontSize: this.reportData.isWeb?20:13,
            }
          },
          legend: {
            bottom: '15',
            itemHeight: 12,
            itemWidth: 12,
            textStyle: {
              fontSize: this.reportData.isWeb?20:13,
              color: '#444',
            },
            data: legendData,
          },
          grid: {
            top: this.reportData.isWeb?'80':'40',
            bottom: this.reportData.isWeb?'140':id == 'echarts4' || id == 'echarts5'?'170':'110',
            left: this.reportData.isWeb?'100':id == 'echarts4' || id == 'echarts5'?'50':'30',
            right: this.reportData.isWeb?'50':'0',
          },
          xAxis: { 
            type: 'category',
            axisLabel: {  
              interval:0,  
              rotate:this.reportData.isWeb?10:45,  
              textStyle: {
                fontSize: this.reportData.isWeb?20:13,
                color: '#444',
              },
            },
            data: xData,
            // axisTick:{//x轴刻度线
            //   show:false
            // },
            // axisLine:{//x轴
            //   show:false
            // }
          },
          yAxis: {
            axisLabel: {   
              textStyle: {
                fontSize: this.reportData.isWeb?20:13,
                color: '#444',
              },
            },
            // axisTick:{
            //   show:false
            // },
            // axisLine:{
            //   show:false
            // }
          },
          series: [
            {
              name: legendData[0],
              type: 'bar',
              barWidth: this.reportData.isWeb?40:20,
              data: data1,
              barGap: this.reportData.isWeb?'50%':'0%',
              itemStyle: {
                normal: {
                  color: '#ffc000',
                },
              },
              label: {
                normal: {
                  show: this.reportData.isWeb?true:false,
                  position: 'top',
                  fontSize: this.reportData.isWeb?20:13,
                  color: '#444',
                  formatter: function formatter(params) {
                    return params.data
                  },
                },
              }
            },
            {
              name: legendData[1],
              type: 'bar',
              barWidth: this.reportData.isWeb?40:20,
              data: data2,
              barGap: this.reportData.isWeb?'50%':'0%',
              itemStyle: {
                normal: {
                  color: '#4472c4',
                },
              },
              label: {
                normal: {
                  show: this.reportData.isWeb?true:false,
                  position: 'top',
                  fontSize: this.reportData.isWeb?20:13,
                  color: '#444',
                  formatter: function formatter(params) {
                    return params.data
                  },
                },
              }
            }
          ]
        };
        var myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        if (id == 'echarts2') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl2 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl2 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl2
            )
          })
        } else if(id == 'echarts3') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl3 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl3 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl3
            )
          })
        } else if(id == 'echarts4') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl4 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl4 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl4
            )
          })
        } else if(id == 'echarts5') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl5 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl5 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl5
            )
          })
        } else if(id == 'echarts6') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl6 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl6 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl6
            )
          })
        } else if(id == 'echarts7') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl7 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl7 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl7
            )
          })
        } else if(id == 'echarts8') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl8 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl8 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl8
            )
          })
        } else if(id == 'echarts9') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl9 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl9 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl9
            )
          })
        } else if(id == 'echarts10') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl10 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl10 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl10
            )
          })
        } else if(id == 'echarts11') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl11 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl11 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl11
            )
          })
        } else if(id == 'echarts12') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl12 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl12 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl12
            )
          })
        } else if(id == 'echarts13') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl13 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl13 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl13
            )
          })
        } else if(id == 'echarts14') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl14 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl14 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl14
            )
          })
        } else if(id == 'echarts15') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl15 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl15 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl15
            )
          })
        } else if(id == 'echarts16') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl16 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl16 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl16
            )
          })
        } else if(id == 'echarts17') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl17 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl17 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl17
            )
          })
        } else if(id == 'echarts18') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl18 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl18 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl18
            )
          })
        } else if(id == 'echarts19') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl19 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl19 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl19
            )
          })
        } else if(id == 'echarts20') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl20 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl20 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl20
            )
          })
        }
      },
      drawEchartsScatter(id,data,title,toolTipTitle,unit){
        this.$echarts.registerTransform(ecStat.transform.regression);
        var option = {
          animation: false,
          dataset: [
            {
              source: data
            },
            {
              transform: {
                type: 'ecStat:regression'
                // 'linear' by default.
                // config: { method: 'linear', formulaOn: 'end'}
              }
            }
          ],
          title: {
            text: title,
            // subtext: '',
            left: 'center',
            textStyle:{
              //文字颜色
              color:'#333',
              fontWeight: 'bold',
              fontSize: this.reportData.isWeb?20:13,
            }
          },
          grid: {
            top:this.reportData.isWeb?'50':'50',
            bottom: this.reportData.isWeb?'80':'80',
          },
          // legend: {
          //   bottom: 5
          // },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
            },
            formatter: function formatter(params) {
              var result = ''
              for (var i = 0; i < params.length; i++) {
                var item = params[i]
                if(i<2){
                  result +=
                    item.marker +
                    ' ' +
                    item.seriesName +
                    ' : ' +
                    // (i==0?params[0].data[0]:params[0].data[1]) + (i==1?'%</br>':unit?unit+'</br>':'</br>')
                    (i==1?params[0].data[0]:params[0].data[1]) + (i==1?'%</br>':unit?unit+'</br>':'</br>')
                }
              }
              return result
            },
            extraCssText: 'z-index:999;', //设置层级
          },
          xAxis: {
            // name:'手卫生依从率',
            // nameTextStyle: {
            //     fontSize: this.reportData.isWeb?20:13,
            //     color: '#444',
            //     padding: [0, 0, 0 , -80]    // 四个数字分别为上右下左与原位置距离
            // },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              textStyle: {
                fontSize: this.reportData.isWeb?20:13,
                color: '#444',
              }
            }
          },
          yAxis: {
            name:toolTipTitle,
            nameTextStyle: {
                fontSize: this.reportData.isWeb?20:13,
                color: '#444',
                padding: [0, 0, 0, 110]    // 四个数字分别为上右下左与原位置距离
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              textStyle: {
                fontSize: this.reportData.isWeb?20:13,
                color: '#444',
              }
            }
          },
          series: [
            {
              name: toolTipTitle,
              type: 'scatter'
            },
            {
              name: '手卫生依从率',
              type: 'scatter'
            },
            {
              name: 'line', // 线性回归
              type: 'line',
              datasetIndex: 1,
              symbolSize: 0.1,
              symbol: 'circle',
              label: { 
                show: false, // 是否显示计算公式（自动）
                fontSize: 16 
              },
              labelLayout: { dx: -20 },
              encode: { label: 2, tooltip: 1 }
            }
          ]
        };
        let myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        if(id == 'echarts21') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl21 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl21 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl21
            )
          })
        } else if(id == 'echarts22') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl22 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl22 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl22
            )
          })
        } else if(id == 'echarts23') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl23 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl23 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl23
            )
          })
        } else if(id == 'echarts24') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl24 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl24 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl24
            )
          })
        } else if(id == 'echarts25') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl25 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl25 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl25
            )
          })
        } else if(id == 'echarts26') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl26 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl26 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl26
            )
          })
        } else if(id == 'echarts27') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl27 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl27 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl27
            )
          })
        } else if(id == 'echarts28') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl28 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl28 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl28
            )
          })
        } else if(id == 'echarts29') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl29 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl29 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl29
            )
          })
        } else if(id == 'echarts30') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl30 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl30 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl30
            )
          })
        } else if(id == 'echarts31') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl31 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl31 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl31
            )
          })
        } else if(id == 'echarts32') {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl32 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl32 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl32
            )
          })
        }

      }
    },
  }
</script>
<style lang='scss' scoped>
  .v-echarts {
    min-width: 90vw;
    min-height: 400px;
  }
  #echarts1 {
    max-width: 90vw;
    min-width: 90vw;
    max-height: 300px;
    min-height: 300px;
  }
  .web-echarts-heightFixed {
    max-width: 800px!important;
    min-width: 800px!important;
    margin:0 auto;
  }
  @import './public.scss';
</style>
